import { FormProvider } from "react-hook-form";
import { TFormProps } from "./models";

export const Form: TFormProps = ({ children, ...methods }) => {
  return <FormProvider {...methods}>{children}</FormProvider>;
};
